var map = {
	"./Group 1.png": "da1f",
	"./Pishro_Splash – 1.png": "36dc",
	"./avatar.png": "690a",
	"./banner.png": "d22d",
	"./bell.png": "aefd",
	"./bg-detail-report.png": "520a",
	"./bg-keyboard.png": "9552",
	"./bg-membership.png": "b3e8",
	"./bg-purple.png": "8666",
	"./bg-report.png": "2128",
	"./bg-star.png": "e8c6",
	"./bg-student.png": "c92b",
	"./bmi.png": "521b",
	"./brain.png": "5674",
	"./brain1.png": "7bae",
	"./category1.png": "8e48",
	"./detail.png": "152c",
	"./detail1.png": "6e0d",
	"./detail3.png": "47a8",
	"./detail4.png": "3f15",
	"./diet.png": "86b3",
	"./diet1.png": "4023",
	"./exam.png": "c6c8",
	"./file-report.png": "e8ea",
	"./img.png": "ba75",
	"./information1.png": "1c99",
	"./keyboard.png": "af79",
	"./loggedIn.png": "7713",
	"./login-banner.png": "183a",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./medal.png": "3cd4",
	"./newspaper.png": "e3b4",
	"./newspaper1.png": "1669",
	"./online-test.png": "ff77",
	"./onlineClass.png": "fb33",
	"./onlineSession.png": "2fa6",
	"./organize.png": "4d58",
	"./pishroLogo.png": "8b0a",
	"./report.png": "ad9f",
	"./report1.png": "9973",
	"./report2.png": "f519",
	"./report3.png": "93f0",
	"./report4.png": "c9f4",
	"./silver-medal.png": "6bf3",
	"./sleeping.png": "a889",
	"./splash.png": "2dd6",
	"./star-bg.png": "53dd",
	"./star.png": "ba5a",
	"./student.png": "f070",
	"./vote.png": "2ddd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";